import React, { useState } from 'react';
import Web3 from 'web3';
import TokenDeployerABI from './TokenDeployerABI.json';
import './App.css';

function App() {
  const [connected, setConnected] = useState(false);
  const [account, setAccount] = useState('');
  const [tokenName, setTokenName] = useState('');
  const [tokenSupply, setTokenSupply] = useState('');
  const [tokenSymbol, setTokenSymbol] = useState('');
  const [transactionLink, setTransactionLink] = useState('');

  const connectMetamask = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.enable();
        const web3 = new Web3(window.ethereum);
        const accounts = await web3.eth.getAccounts();
        setAccount(accounts[0]);
        setConnected(true);
      } catch (error) {
        console.error(error);
      }
    } else {
      console.error('Metamask extension not detected');
    }
  };

  const handleTokenNameChange = (event) => {
    setTokenName(event.target.value);
  };

  const handleTokenSupplyChange = (event) => {
    setTokenSupply(event.target.value);
  };

  const handleTokenSymbolChange = (event) => {
    setTokenSymbol(event.target.value);
  };

  const generateToken = async () => {
    try {
      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();
      const contractAddress = '0x85eeBb904AE77Dd1a2A8BDe0A2ec68eb5a6b4f99'; // Replace with your deployed contract address
      const contract = new web3.eth.Contract(TokenDeployerABI, contractAddress);

      const transaction = await contract.methods.deployToken(tokenName, tokenSymbol, tokenSupply).send({ from: accounts[0] });
      console.log('Token deployed successfully!');

      const etherscanUrl = `https://sepolia.etherscan.io/tx/${transaction.transactionHash}`;
      setTransactionLink(etherscanUrl);
    } catch (error) {
      console.error('Token deployment failed:', error);
    }
  };

  return (
    <div className="App">
      <h1 className="title">MemeCoin</h1>
      <p className="intro">
        Welcome to the world of MemeCoin!
      </p>
      {connected ? (
        <div className="content">
          <p className="account-info">Connected Account: {account}</p>
          <div className="input-group">
            <label className="label">
              Token Name:
              <input className="input" type="text" value={tokenName} onChange={handleTokenNameChange} />
            </label>
          </div>
          <div className="input-group">
            <label className="label">
              Token Supply:
              <input className="input" type="number" value={tokenSupply} onChange={handleTokenSupplyChange} />
            </label>
          </div>
          <div className="input-group">
            <label className="label">
              Token Symbol:
              <input className="input" type="text" value={tokenSymbol} onChange={handleTokenSymbolChange} />
            </label>
          </div>
          <button className="generate-button" onClick={generateToken}>Generate Token</button>
          {transactionLink && (
            <div className="transaction-link">
              Transaction completed! View it on <a href={transactionLink} target="_blank" rel="noopener noreferrer">Etherscan</a>.
            </div>
          )}
        </div>
      ) : (
        <button className="connect-button" onClick={connectMetamask}>Connect Metamask</button>
      )}
      <div className="uniswap-iframe">
        <iframe
          src="https://app.uniswap.org/#/swap?outputCurrency=0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359"
          title="Uniswap Swap Widget"
          frameBorder="0"
          width="100%"
          height="660px"
        ></iframe>
      </div>
    </div>
  );
      }  

export default App;
